import {Box} from 'src/design/atoms/Box';
import {Group} from 'src/design/atoms/Group';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {IconThumbDownFilled, IconThumbUpFilled} from '@tabler/icons-react';
import type {FC} from 'react';
import type {AssistantMessageFeedbackResponse} from 'src/api/ProactApiClient';
import {AssistantFeedbackRatingEnum} from 'src/api/ProactApiClient';
import {feedbackRatingLabel, feedbackReasonLabel} from './messageFeedback';

export interface MessageFeedbackSummaryProps {
  feedback: AssistantMessageFeedbackResponse;
}

/**
 * Read-only stored vote on a Scout reply: rating, reason, and comment.
 * @registry Read-only Scout reply vote for admin transcript views.
 */
export const MessageFeedbackSummary: FC<MessageFeedbackSummaryProps> = ({
  feedback,
}) => {
  const isUp = feedback.rating === AssistantFeedbackRatingEnum.Up;
  const verdict = feedbackRatingLabel(feedback.rating);
  const reason = feedbackReasonLabel(feedback.reason);

  return (
    <Group gap={6} wrap="nowrap" align="flex-start">
      <Box
        c={isUp ? 'green.7' : 'red.7'}
        style={{display: 'flex', flexShrink: 0, marginTop: 2}}>
        {isUp ? (
          <IconThumbUpFilled size={14} aria-hidden />
        ) : (
          <IconThumbDownFilled size={14} aria-hidden />
        )}
      </Box>
      <Stack gap={2} style={{minWidth: 0}}>
        <Text size="xs">{reason ? `${verdict}: ${reason}` : verdict}</Text>
        {feedback.comment && (
          <Text size="xs" style={{whiteSpace: 'pre-wrap'}}>
            {feedback.comment}
          </Text>
        )}
      </Stack>
    </Group>
  );
};
